import PropTypes from 'prop-types';
import React from 'react';

import styles from './Switch.module.scss';

/**
 * Purely presentational pill-shaped toggle switch with a sliding circular
 * handle. Does not handle its own click events - wrap it in a clickable
 * element (e.g. a button) and drive the `on` prop from that element's
 * click handler, matching how it is used in JobActionCards.
 */
const Switch = ({ on, ariaLabel, className }) => {
  const switchClassName = [styles.switch, on ? styles.switchOn : '', className]
    .filter(Boolean)
    .join(' ');

  return (
    <span
      role="switch"
      aria-checked={on}
      aria-label={ariaLabel}
      className={switchClassName}
    >
      <span className={styles.switchHandle} />
    </span>
  );
};

Switch.propTypes = {
  on: PropTypes.bool,
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
};

Switch.defaultProps = {
  on: false,
  ariaLabel: undefined,
  className: '',
};

export default Switch;
